import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from '@angular/core';
import { NgForm, ControlContainer } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Answers, IQuestionModel } from '@care-portals/api-interfaces';
import { ConsultationFacade } from '../../../+store/consultation/consultation.facade';

@Component({
  selector: 'my-health-admin-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.less'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class QuestionComponent implements OnInit, OnChanges, OnDestroy {
  @Input() question: IQuestionModel;
  @Input() data: any;
  @Input() editMode: boolean;
  @Input() brand: string;
  @Input() customerId: string;
  @Input() allAnswers: any;
  answers: Answers;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private consultationFacade: ConsultationFacade) {}

  ngOnInit(): void {
    this.consultationFacade.selectedConsultation$
      .pipe(takeUntil(this.destroy$))
      .subscribe(consultation => {
        this.answers = consultation?.answers || {};
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      if (this.data === undefined) {
        this.data = {};
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  get validateCheck() {
    const options = this.question.answer.options;

    for (const a in options) {
      if (this.data[options[a].key]) return true;
    }
    return '';
  }
}
